<template>
  <div class="is-flex is-flex-direction-column mt-2">
    <p class="has-text-left has-text-info-dark">
      All players ({{ simul.players ? simul.players.length : 0 }})
    </p>
    <div class="mt-2" style="width: 100%">
      <b-table
        :data="players.length ? players : []"
        bordered
        hoverable
        focusable
      >
        <b-table-column field="name" label="Name" v-slot="{ row: player }">
          <ProfileCard
            :player="player"
            :rating="player.stats ? player.stats.rating : null"
          />
        </b-table-column>

        <b-table-column
          field="rating"
          label="Rating"
          centered
          v-slot="{ row: player }"
        >
          {{ player.stats ? player.stats.rating : null }}
        </b-table-column>

        <b-table-column v-if="isOwner" v-slot="{ row: player }">
          <b-button
            v-if="isOwner"
            label="Kick out"
            type="is-primary"
            @click="removePlayer(player)"
          />
        </b-table-column>

        <template #empty>
          <div class="has-text-left">No players</div>
        </template>
      </b-table>
    </div>
  </div>
</template>

<script>
import ProfileCard from "@/components/players/ProfileCard.vue";
import { firestore, database } from "@/services/firebase";
import { MatchesAPI } from "@/services/api";

export default {
  name: "SimulPlayersTable",

  components: {
    ProfileCard,
  },

  props: ["simul", "isOwner"],

  data() {
    return {
      players: [],
    };
  },

  watch: {
    simulPlayers: {
      immediate: true,
      async handler() {
        if (!this.simulPlayers.length) {
          this.players = [];
          return;
        }

        const usernames = this.simulPlayers.map((item) => item.username);
        const playersStats = await MatchesAPI.getPlayersStats(usernames);

        this.players = this.simulPlayers.map((p) => {
          const playerStats = playersStats[usernames.indexOf(p.username)];
          return { ...p, stats: playerStats };
        });
      },
    },
  },

  computed: {
    simulPlayers() {
      return this.simul.players || [];
    },
  },

  methods: {
    async removePlayer(player) {
      // remove player
      await firestore
        .collection("simuls")
        .doc(this.simul.id)
        .update({
          players: this.simul.players.filter(
            (p) => p.user_id !== player.user_id
          ),
        });

      // Also remove the request, so that user can be invited again
      await database
        .ref(`rooms/lobby/players/${player.user_id}/challenge`)
        .remove();

      if (this.$route.name === "simul") {
        return;
      }

      this.$router.push({
        name: "simul",
        params: {
          simulId: this.simul.id,
        },
      });
    },
  },
};
</script>

<style scoped></style>
